import { FormStateContext } from "@/components/bli-medlem/form-state-context";
import { Suspense, useContext, useEffect } from "react";
import { FormComponent } from "../base/form";
import { Heading } from "../base/heading";
import { HorizontalSpacer } from "../layout/horizontal-spacer";
import { PageContent } from "../layout/page-content";
import { Loader } from "../ui/loader";
import { Text } from "../ui/text";
import { StepIndicator } from "./step-indicator";
import { UserJourney } from "./types";

export const Form = () => {
  const { step, currentStepIndex, steps, formData, goTo } = useContext(FormStateContext);

  // biome-ignore lint/correctness/useExhaustiveDependencies: This could be solved by introducing a useState with a flag shouldScrollToTop which is dependant on currentStepIndex. But I consider that to be unnecessarily complicated
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentStepIndex]);

  return (
    <FormComponent>
      <StepIndicator
        currentStepIndex={currentStepIndex}
        goTo={goTo}
        numberOfSteps={steps.filter((step) => !step.hideInStepIndicator).length}
        selectedValues={formData.selectedValues}
        steps={steps.filter((step) => !step.hideInStepIndicator)} // exclude last two steps (payment and receipt)
      />
      <HorizontalSpacer />

      <PageContent width="large">
        {!step?.hideSubTitle && (
          <>
            <Text value={formData.userJourney === UserJourney.Single ? "Tren nå" : "Bli 3T-medlem"} />
            <HorizontalSpacer size="x-small" />
          </>
        )}

        <Heading type="h1">{step?.title}</Heading>
      </PageContent>

      <Suspense fallback={step?.loader ?? <Loader />}>{step?.component}</Suspense>
    </FormComponent>
  );
};
